import { useNavigate } from 'react-router-dom'

import { DocumentNode } from '@apollo/client'
import { ConvertQuoteIntoInvoiceDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'

import handleResultWithFlash from 'modules/finance/lib/handleResultWithFlash'

export function useConvertQuoteIntoInvoice(options?: {
  refetchQueries?: Array<string | DocumentNode>
}) {
  const { company } = useCurrentSession()
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const [convertIntoInvoice] = useMutation(ConvertQuoteIntoInvoiceDocument, {
    extractorFn: (data) => data.financeMutations.convertToInvoiceFinanceQuote,
    ...(options?.refetchQueries ? { refetchQueries: options.refetchQueries } : {}),
  })

  return async (quoteId: number) => {
    const result = await convertIntoInvoice({
      variables: {
        id: quoteId,
        companyId: company.id,
      },
    })

    const handled = handleResult(result, handleResultWithFlash())

    if (handled.success) {
      track(trackingEvents.accounting.quotes.conversionIntoInvoice)
      navigate(
        navigation.finance.sales.salesInvoices.invoiceId.fullPath({
          invoiceId: Number(
            handled.data.quote?.financialDocumentAssociation?.financialDocument?.id
          ),
        })
      )
    }
  }
}
